export class PricingCopilotMatrixUtilityTableData {
	public stateShort: string;
	public utilityName: string;
	public priorYear: string;
	public priorYearAbbreviation: string;
	public currentMonth: string;
	public currentMonthAbbreviation: string;
	public reportingPercentage: number;
	public priorSTGM: number;
	public currentSTGM: number;
	public estimatedSTGM: number;
	public diffSTGM: number;
	public diffTermVolume: number;
	public priorCount: number;
	public currentCount: number;
	public estimatedCount: number;
	public priorTermVolume: number;
	public currentTermVolume: number;
	public estimatedTermVolume: number;
	public winRate: number;
	public deltaToBest: number;
	public ptcVsMinOffer: number;
	public rank: number;
	public previousRank: number;
	public rateAdjustment: number;
	public adjustmentStateId: string;
	public adjustmentUtilityId: string;
	public adjustmentZone: string;
	public adjustmentRateClass: string;
	public adjustmentAnnualUsage: number;
	public adjustmentEffectiveDate: string;
	public adjustmentTerm: number;

	constructor(tableData?: PricingCopilotMatrixUtilityTableData) {
		Object.assign(this, tableData);
	}
}
